import React from "react";
import { Container, PageTitle, TitleContainer } from "../../components/refactor/components";
import Button from "../../components/Button";
import { InertiaLink } from "@inertiajs/inertia-react";
import { PencilIcon, SwitchVerticalIcon } from "@heroicons/react/outline";
import Label from "../../components/Label";
import { Alert } from "@mui/material";

const Show = ({ entry, priceHistory, flash, roles }) => {
    const getLabelForStorageType = (storageType) => {
        const labels = {
            "PALLET": "Palette",
            "PARCEL": "Paket"
        };

        return labels[storageType] ?? storageType;
    };

    const formatDateIfAvailable = (date) => {
        if (!date) return;

        return new Intl.DateTimeFormat("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }).format(new Date(date));
    };

    const buttons = [];

    if (roles.includes("Administrator")) {
        buttons.push(
            <InertiaLink
                key="edit"
                href={`/admin/warehouse/${entry.id}/edit`}
            >
                <Button
                    IconComponent={PencilIcon}
                    type="ghost"
                >
                    Bearbeiten
                </Button>
            </InertiaLink>
        );

        buttons.push(
            <InertiaLink
                key="takeout"
                method="POST"
                href={`/admin/warehouse/${entry.id}/takeout`}
            >
                <Button
                    IconComponent={SwitchVerticalIcon}
                    type="primary"
                    disabled={!!entry.takeout_date}
                >
                    {!!entry.takeout_date ? "Artikel wurde bereits ausgelagert" : "Auslagern"}
                </Button>
            </InertiaLink>
        );
    }

    return (
        <div className="space-y-6">
            <Container>
                <PageTitle
                    title={entry.article.name}
                    buttons={buttons}
                />
            </Container>

            {!!flash && flash.message && (
                <Container>
                    <Alert severity={flash.style} variant="filled">{flash.message}</Alert>
                </Container>
            )}

            <TitleContainer title="Lagerbestand">
                <div className="space-y-6 divide-y divide-gray-200">
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <Label>Markt</Label>
                        <div>{entry.market.name}</div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-6">
                        <Label>Einlagerungsdatum</Label>
                        <div>{formatDateIfAvailable(entry.created_at)}</div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-6">
                        <Label>Auslagerungsdatum</Label>
                        <div>{formatDateIfAvailable(entry.takeout_date)}</div>
                    </div>
                    {roles.includes("Administrator") ? (
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-6">
                            <Label>Lagerplatz</Label>
                            <div>{entry.storage_location?.name}</div>
                        </div>
                    ) : null}
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-6">
                        <Label>Lagertyp</Label>
                        <div>{getLabelForStorageType(entry.storage_type)}</div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-6">
                        <Label>Menge</Label>
                        <div>{entry.amount}</div>
                    </div>
                </div>
            </TitleContainer>

            <TitleContainer title="Artikel">
                <div className="space-y-6 divide-y divide-gray-200">
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                        <Label>Artikelbezeichnung</Label>
                        <div>{entry.article.name}</div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-6">
                        <Label>Artikelnummer</Label>
                        <div>{entry.article.article_number}</div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-6">
                        <Label>EAN-Nummer</Label>
                        <div>{entry.article.eanNumber}</div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-6">
                        <Label>Hersteller</Label>
                        <div>{entry.article.manufacturer}</div>
                    </div>
                </div>
            </TitleContainer>

            {roles.includes("Administrator") ? (
                <TitleContainer title="Abrechnungsinformationen">
                    <p className="text-gray-400 mb-6">Diese Informationen gelten der Vollständigkeit, um die Preise eines Lagerartikels zu überprüfen.</p>

                    {!!priceHistory && priceHistory.actions.length > 0 && priceHistory.actions.map(action =>(
                        <pre>{action}</pre>
                    ))}

                    <span className="inline-flex items-center rounded-full bg-blue-100 px-3 py-0.5 text-md font-medium text-purple-800 mt-6">
                        Gesamt: {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(priceHistory.total)}
                    </span>
                </TitleContainer>
            ) : null}
        </div>
    );
};

export default Show;
